export default __webpack_public_path__ + "locales/zh-CN/DeleteProfileEverDialog.json?hash=18d403faabd3814596103c10cdd254b6";